// Story 11.5 — Snippets de templates YAML para insert desde el command
// palette. Sintaxis Monaco-style con `${1:label}` para tab stops.

export interface YamlSnippet {
  id: string;
  name: string;
  description: string;
  /** Cuerpo del snippet con placeholders Monaco. */
  body: string;
}

export const YAML_SNIPPETS: YamlSnippet[] = [
  {
    id: 'step:send_message',
    name: 'Insert step: send_message',
    description: 'Step que envía un mensaje de texto al usuario.',
    body: `- id: \${1:step-id}\n  sendMessage:\n    type: text\n    body: "\${2:Hola}"\n`,
  },
  {
    id: 'step:wait_for',
    name: 'Insert step: wait_for',
    description: 'Step que espera input del usuario.',
    body: `- id: \${1:step-id}\n  waitFor: \${2:reply}\n`,
  },
  {
    id: 'step:condition',
    name: 'Insert step: condition',
    description: 'Step con branches según el reply del usuario.',
    body: `- id: \${1:step-id}\n  waitFor: reply\n  conditions:\n    - if: "\${2:reply.id == 'yes'}"\n      goto: \${3:next-flow}\n    - else: true\n      goto: \${4:cancel-flow}\n`,
  },
  {
    id: 'step:db_action',
    name: 'Insert step: db_action',
    description: 'Step que ejecuta una operación de DB.',
    body: `- id: \${1:step-id}\n  action:\n    type: db_query\n    table: \${2:orders}\n    where:\n      \${3:status}: \${4:active}\n    target: \${5:rows}\n`,
  },
  {
    id: 'step:goto',
    name: 'Insert step: goto',
    description: 'Step que salta a otro flow.',
    body: `- id: \${1:step-id}\n  goto: \${2:target-flow}\n`,
  },
  {
    id: 'step:use_component',
    name: 'Insert step: use_component',
    description: 'Step que invoca un componente reutilizable.',
    body: `- id: \${1:step-id}\n  useComponent: \${2:component-name}\n`,
  },
  {
    id: 'flow:boilerplate',
    name: 'Insert flow boilerplate',
    description: 'Estructura completa de un nuevo flow.',
    body: `\${1:flow-name}:\n  steps:\n    - id: greet\n      sendMessage:\n        type: text\n        body: "\${2:Hola, ¿qué necesitás?}"\n    - id: wait\n      waitFor: reply\n`,
  },
];

/** Lookup por id. Returns null si no existe. */
export function findSnippet(id: string): YamlSnippet | null {
  return YAML_SNIPPETS.find((s) => s.id === id) ?? null;
}
